// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Connections_tableWrapper__CKNwc","relationshipCellWrapper":"Connections_relationshipCellWrapper__6mQjK","relationship":"Connections_relationship__9jUfe"};